export const formConstants = {
    SUBMIT_GREENSTREET_FORM_SUCCESS: 'SUBMIT_GREENSTREET_FORM_SUCCESS',
    SUBMIT_DISTRICT_FORM_SUCCESS: 'SUBMIT_DISTRICT_FORM_SUCCESS',
    SUBMIT_GREENSTREET_FORM_FAILURE: 'SUBMIT_GREENSTREET_FORM_FAILURE',
    SUBMIT_DISTRICT_FORM_FAILURE: 'SUBMIT_DISTRICT_FORM_FAILURE',
    CLEAR_MESSAGE: 'CLEAR_MESSAGE',
}
